import { Typography } from "@avenue-8/sidekick-ui";
import { TeamBrandingSectionView } from "@cma/presentation-generation-logic/models/section-view";
import { textFormatter } from "@shared/utils/text-formatter";
import LanguageIcon from "@mui/icons-material/Language";
import { PresentationSectionViewProps } from "../PresentationSectionProps";
import {
  ContactInfoItem,
  TeamLogoContainer,
  Text,
} from "./TeamBranding.styles";
import {
  PrintPaper,
  PrintPage,
} from "@cma/chat-widgets/cma/components/shared/Print.styles";
import styled from "@emotion/styled";

const PrintTeamCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  box-sizing: border-box;
`;

interface Props extends PresentationSectionViewProps<TeamBrandingSectionView> {}

export const TeamBrandingPrint = (props: Props) => {
  const { sectionView } = props;
  const { id, name, logo, website, preferences } = sectionView;
  const { showWebsite } = preferences || {};

  const clickableUrl = textFormatter.formatClickableUrl(website ?? null);
  const prettyUrl = textFormatter.formatPrettyUrl(website ?? null);

  return (
    <PrintPaper id={id}>
      <PrintPage>
        <PrintTeamCard>
          {logo && (
            <TeamLogoContainer>
              <img src={logo} alt={name ?? ""} />
            </TeamLogoContainer>
          )}

          <ContactInfoItem>
            <Typography variant="h4">{name}</Typography>
          </ContactInfoItem>

          {showWebsite && clickableUrl && prettyUrl && (
            <Text>
              <LanguageIcon fontSize="small" />
              <span>{prettyUrl}</span>
            </Text>
          )}
        </PrintTeamCard>
      </PrintPage>
    </PrintPaper>
  );
};
